module.exports = __webpack_public_path__ + "static/media/MovingApp_android_3.a7014deb.jpg";